// Tyler.API.MetaData.Key
export enum Key {
    A = 0,
    B = 1,
    C = 2,
    D = 3,
    E = 4,
    F = 5,
    G = 6,
    H = 7,
    I = 8,
    J = 9,
    K = 10,
    L = 11,
    M = 12,
    N = 13,
    O = 14,
    P = 15,
    Q = 16,
    R = 17,
    S = 18,
    T = 19,
    U = 20,
    V = 21,
    W = 22,
    X = 23,
    Y = 24,
    Z = 25,
    ArrowDown = 26,
    ArrowLeft = 27,
    ArrowRight = 28,
    ArrowUp = 29,
    Asterisk = 30,
    Backspace = 31,
    Delete = 32,
    End = 33,
    Enter = 34,
    Home = 35,
    Tab = 36,
    F1 = 37,
    F2 = 38,
    F3 = 39,
    F5 = 40,
    F6 = 41,
    F7 = 42,
    F8 = 43,
    F9 = 44,
    F10 = 45,
    F11 = 46,
    F12 = 47
}
